import React from 'react';
import { Icon } from '../../index';

export interface CityStateHintProps {
  city: string;
  state: string;
  clickHandler: () => void;
}

const CityStateHint: React.FC<CityStateHintProps> = ({
  city,
  state,
  clickHandler,
}) => {
  return (
    <span className="ui-zipcode-city_state-hint">
      <a onClick={clickHandler} data-test-id="baa-input-hint">
        <span>
          {city},{state}
          <Icon className="edit-city-state-svg" name="pencil" size="x-small" />
        </span>
      </a>
    </span>
  );
};

export default CityStateHint;
